import { getAdditionalErrorData } from '~/utils/error-handling'
import { logger } from '~/utils/sentry/client-only-logger'
type BaseError = {
  statusCode?: number
  statusMessage?: string
  message?: string
}

/**
 * Makes the error Fatal and triggers full screen 404/500 pages
 *
 * Recommended: Should be called in the end of component setup,
 * Otherwise you will get an error
 * about other composables (below it) being called outside setup functions
 */
export const useShowErrorPage = (
  error: Ref<BaseError | null | undefined>,
): void => {
  watch(
    error,
    () => {
      const e = error.value
      if (e) {
        logger.error(e, {
          additionalData: getAdditionalErrorData({
            errorHandler: 'useShowErrorPage',
          }),
        })
        showError(e)
      }
    },
    { immediate: true },
  )
}
